// extracted by mini-css-extract-plugin
export var quantityInput = "_m4-0";